export default {
  DELETE_FILE_SUCCESS: 'Contentseite wurde erfolgreich gelöscht',
  ADD_CONTENT: 'Inhalte zum Teilen hinzufügen',
  ADD_CONTENT_INFO: 'Laden Sie hier Ihre Dokumente, Links, Bilder oder andere Materialien hoch, um sie mit Ihren Besuchern zu teilen.',
  NO_CONTENT: 'Sie haben noch keine Dateien oder Links hinzugefügt!',
  UPLOAD_FILES: 'Dateien hochladen',
  ADD_URL: 'URL hinzufügen',
  ADDED_CONTENT: 'Hinzugefügte Dateien und URLs',
  URL: 'Url',
  ADD_URL_SUCCESS: 'URL erfolgreich generiert und gespeichert!',
  DISPLAY_NAME: 'Namen anzeigen',
  BROCHURE: 'Broschüre',
  CHOOSE_FILE: 'Datei auswählen',
  DRAG_DROP: 'Drag & Drop',
  TO_UPLOAD: 'hochzuladen',
  MAX_FILE_SIZE: 'Maximal 3 MB sind erlaubt',
  MAX_LEN_ERR: 'Dateiname zu lang',
  MAX_SIZE_ERR: 'Dateigröße überschritten',
  FILES_UPLOAD_SUCCESS: 'Dateien erfolgreich hochgeladen'
}
